// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"e9b03198","274":"32d3ab8b","448":"a8706fd4","450":"e15c684a","509":"8e4f1463","786":"32d3ab8b"}[chunkId] + ".chunk.css";
};